import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useGlobalContext } from '../../context/globalContext';
import History from '../../History/History';
import { InnerLayout } from '../../styles/Layouts';
import { dollar } from '../../utils/Icons';
import Chart from '../Chart/Chart';
import moment from 'moment';
import 'moment/locale/fr';
function Dashboard() {
    const {totalExpenses, totalIncome, getIncomes, getExpenses, moisPrecedent, MoisEncours, moisPrecedentR, MoisEncoursR, JourEncours } = useGlobalContext()

    useEffect(() => {
        getIncomes()
        getExpenses()
    }, [])
    var fr = moment().locale('fr');
    var fr2 = moment().locale('fr');
    var fr3 = moment().locale('fr');
    var fr4 = moment().locale('fr');
    return (
        <DashboardStyled>
            <InnerLayout>
                <h1>All Transactions</h1>
                <div className="stats-con">
                    <div className="chart-con">
                        <Chart />
                        <div className="amount-con">
                            <div className="income">
                                <h3>Total Recup</h3>
                                <p>
                                    {dollar} {totalIncome()}
                                </p>
                            </div>
                            <div className="expense">
                                <h3>Total Primes</h3>
                                <p>
                                    {dollar} {totalExpenses()}
                                </p>
                            </div>
                            <div className="income">
                                <h3>Prime {fr.subtract("1","M").format("MMMM")}</h3>
                                <p>
                                    {dollar} {moisPrecedent(fr)}
                                </p>
                            </div>
                            <div className="income">
                                <h3>Recup {fr3.subtract("1","M").format("MMMM")}</h3>
                                <p>
                                    {dollar} {moisPrecedentR(fr3)}
                                </p>
                            </div>
                            <div className="income">
                                <h3>Prime {fr2.format("MMMM")}</h3>
                                <p>
                                    {dollar} {MoisEncours(fr2)}
                                </p>
                            </div>

                            <div className="income">
                                <h3>Recup {fr4.format("MMMM")}</h3>
                                <p>
                                    {dollar} {MoisEncoursR(fr4)}
                                </p>
                            </div>
                            <div className="income">
                                <h3>Prime {fr2.format("DD MMMM")}</h3>
                                <p>
                                    {dollar} {JourEncours(fr2)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="history-con">
                        <History />
                    </div>
                </div>
            </InnerLayout>
        </DashboardStyled>
    )
}

const DashboardStyled = styled.div`
    .stats-con{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 2rem;
        .chart-con{
            grid-column: 1 / 4;
            height: 400px;
            .amount-con{
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 2rem;
                margin-top: 2rem;
                .income, .expense{
                    grid-column: span 1;
                }
                .income, .expense, .balance{
                    background: #FCF6F9;
                    border: 2px solid #FFFFFF;
                    box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
                    border-radius: 20px;
                    padding: 1rem;
                    p{
                        font-size: 1.5rem;
                        font-weight: 700;
                    }
                }

                .balance{
                    grid-column: 2 / 4;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    p{
                        color: var(--color-green);
                        opacity: 0.6;
                        font-size: 4.5rem;
                    }
                }
            }
        }

        .history-con{
            grid-column: 4 / -1;
            h2{
                margin: 1rem 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .salary-title{
                font-size: 1.2rem;
                span{
                    font-size: 1.8rem;
                }
            }
            .salary-item{
                background: #FCF6F9;
                border: 2px solid #FFFFFF;
                box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.06);
                padding: 1rem;
                border-radius: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p{
                    font-weight: 600;
                    font-size: 1.6rem;
                }
            }
        }
    }
`;

export default Dashboard